// From https://stackoverflow.com/questions/2450954/how-to-randomize-shuffle-a-javascript-array

export function shuffle(array) {
  var currentIndex = array.length,
    temporaryValue,
    randomIndex;

  const result = [...array];
  // While there remain elements to shuffle...
  while (0 !== currentIndex) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    // And swap it with the current element.
    temporaryValue = result[currentIndex];
    result[currentIndex] = result[randomIndex];
    result[randomIndex] = temporaryValue;
  }

  return result;
}
